import { Vue } from 'vue-property-decorator';
import { ComponentsConstant } from './shared/constants';
import axios from 'axios';
import VueAxios from 'vue-axios';
import Filters from './app.filters';
import VueTheMask from 'vue-the-mask';
import VeeValidate from 'vee-validate';
import { VALIDATE_CONSTANT } from './shared/constants/validate.constants';
import { I18N_VEE_VALIDATE_CONSTANT } from './shared/constants/i18n-vee-validate.constants';
import Toasted from 'vue-toasted';
import Spinner from 'vue-simple-spinner';
import Loading from 'vue-loading-overlay';
import vClickOutside from 'v-click-outside';
import Vue2TouchEvents from 'vue2-touch-events';
import './sass/main.scss';
import 'vue-loading-overlay/dist/vue-loading.css';
import 'moment/locale/pt-br.js';
import { AppComponent } from './app';
import {AuthenticationService} from './modules/authentication/services/authentication.service';
import VuejsDialog from 'vuejs-dialog';
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
import { loadAppInfo } from './modules/services/application-config/application-config.util';

Vue.use(vClickOutside);
Vue.use(Vue2TouchEvents);
Vue.use(Filters);
Vue.use(VueTheMask);
Vue.use(Toasted);
Vue.use(Loading);
Vue.use(Spinner);

Vue.use(VeeValidate, {
    locale: 'pt-br',
    dictionary: I18N_VEE_VALIDATE_CONSTANT
});
VALIDATE_CONSTANT.forEach((validation) => {
    VeeValidate.Validator.extend(validation.name, {
        getMessage: validation.properties.getMessage,
        validate: validation.properties.validate
    });
});

Vue.use(VueAxios, axios);

Vue.use(VuejsDialog, {
    html: false, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
    loader: false, // set to true if you want the dailog to show a loader after click on "proceed"
    reverse: false, // switch the button positions (left to right, and vise versa)
    okText: 'Confirmar',
    cancelText: 'Cancelar',
    animation: 'zoom', // Available: "zoom", "bounce", "fade"
    type: 'basic', // coming soon: 'soft', 'hard'
    verification: 'continue', // for hard confirm, user will be prompted to type this to enable the proceed button
    verificationHelp: 'Type "[+:verification]" below to confirm', // Verification help text. [+:verification] will be matched with 'options.verification' (i.e 'Type "continue" below to confirm')
    clicksCount: 3, // for soft confirm, user will be asked to click on "proceed" btn 3 times before actually proceeding
});

ComponentsConstant.forEach(component => {
    Vue.component(component.htmlTag, component.component);
});

if (process.env.VUE_ENV === 'testing') {
    Vue.config.devtools = true;
    Vue.config.silent = false;
}

AuthenticationService
    .login(true)
    .then((auth: boolean) => {
        if (auth) {
            new AppComponent({
                el: '#app',
                props: { keycloak: AuthenticationService.keycloak }
            });

            loadAppInfo();
        } else {
            window.location.reload();
        }
    });
